import React, { useEffect } from 'react';
import Box from 'relements/build/esm/ui/box';
import Text from 'relements/build/esm/ui/text';
import Radio from 'relements/build/esm/input/radio';
import Avatar from 'relements/build/esm/ui/avatar';
import BotStore from '@src/store';
import { Container as Card } from '@src/components/ToolCard/styledComponents';
import { getPortals } from './actions';
import { LOGO_BASE_URL } from './const';
import LoadingState from './LoadingState';

const commonProps = {
  padding: 'zero',
  marginY: 'lg',
  flexWrap: 'wrap',
};

const Portal = ({ setSelection, selectedPortal }) => {
  const [portals, setPortals] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  async function fetchData() {
    setLoading(true);
    const {
      response: {
        body: { data = [] },
      },
    } = await getPortals();
    const updatedPortals = data.map((portal) => ({
      title: portal.screenname,
      logo: portal.logo,
    }));
    setPortals(updatedPortals);
    setLoading(false);
  }
  useEffect(() => {
    BotStore.addChangeListener(fetchData);
    fetchData();
    return () => {
      BotStore.removeChangeListener(fetchData);
    };
  }, []);

  const updateSelection = (val) => {
    if (val) {
      setSelection('portal', val);
    }
  };

  return (
    <>
      <Text variants="body.md" color="haptik.black">
        Select Zoho portal
      </Text>
      {loading ? (
        <LoadingState />
      ) : (
        <Box {...commonProps}>
          <Radio.Themed
            onChange={updateSelection}
            selectedValue={selectedPortal}
            mode="stacked"
          >
            {portals.map((portal) => (
              <Radio.Themed.Item
                value={portal.title}
                key={portal.id}
                selectedValue={selectedPortal}
              >
                <Box width="300px">
                  <Card>
                    <Box alignItems="center" padding={0}>
                      <Avatar
                        url={LOGO_BASE_URL + portal.logo}
                        initials={portal.title.substring(0, 2)}
                        marginRight="md"
                      />
                      <Text>{portal.title}</Text>
                    </Box>
                  </Card>
                </Box>
              </Radio.Themed.Item>
            ))}
          </Radio.Themed>
        </Box>
      )}
    </>
  );
};

export default Portal;
